export default {
	'{days}天后': 'In {days} days',
	今日到期: 'Due today',
	'已过期{days}天': '{days} days overdue',
}
